import React, {useState} from 'react';
import {Box, Button, Grid, IconButton, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Outlet, useNavigate} from 'react-router-dom';

import {Add, Delete, GroupAction} from '@icons/index';

import InfosCard from '@components/cards/infos/Infos.card';
import AlertComponent from '@components/modal/Alert.component';

import {Colors} from '@constants/colors.constants';

const PriceCatalogTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [showDelete, setShowDelete] = useState<number | false>(false);

  return (
    <>
      <Stack flex={1} spacing={1} mt="-35px" pb="25px" overflow="hidden">
        <Box alignSelf="flex-end">
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add/>}
            onClick={() => navigate('add', {replace: true})}>
            {t('settings.priceCatalog.addButton')}
          </Button>
        </Box>
        <Box flex={1} pt="25px" overflow="hidden">
          <Stack height="100%" overflow="hidden" borderRadius="4px" bgcolor={Colors.white}>
            <Stack p="30px" overflow="auto" className="scrollable">
              <Grid container spacing={2} columns={6}>
                {([{id: '1', name: 'Général'}] as any)?.map((container) => (
                  <Grid item key={container.id} xs={1}>
                    <InfosCard
                      title={container.name}
                      menuOptions={(
                        <>
                          <IconButton
                            sx={{mr: '-7px'}}
                            onClick={(evt) => {
                              evt.stopPropagation();
                              navigate(`${container.id}`);
                            }}>
                            <GroupAction style={{height: 14, width: 14}}/>
                          </IconButton>
                          <IconButton
                            onClick={(evt) => {
                              evt.stopPropagation();
                              setShowDelete(container.id);
                            }}>
                            <Delete style={{height: 14, width: 14}}/>
                          </IconButton>
                        </>
                      )}
                      unit={t('global.default') /*t("", {count: , priceCatalog.organisation.length})*/}/>
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Box>
      </Stack>
      <Outlet/>
      {showDelete && (
        <AlertComponent
          title={t('delete.title')}
          description={t('delete.description.priceCatalog')}
          handleClose={() => setShowDelete(false)}
          actions={(
            <>
              <Button
                variant="outlined"
                color="primary"
                disabled={deleteLoading}
                onClick={() => setShowDelete(false)}>
                {t('global.cancel')}
              </Button>
              <Button
                variant="contained"
                disabled={deleteLoading}
                color="primary"
                onClick={() => {
                  setDeleteLoading(true);
                  // containersService.deleteContainer(showDelete).pipe(finalize(() => setDeleteLoading(false))).subscribe({
                  //   next: () => {
                  //     enqueueSnackbar(t("delete.success.priceCatalog"), {variant: "success"})
                  //     setShowDelete(false);
                  //   },
                  //   error: (err) => enqueueSnackbar(err.text, err.options),
                  // });
                }}>
                {t('global.delete')}
              </Button>
            </>
          )}/>
      )}
    </>
  );
};

export default PriceCatalogTab;
